
export enum LABEL_POSITION {
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  BOTTOM = "bottom",
}

export enum ORIENTATION {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

export enum Elements {
  LabelDescription = "LabelDescription",
  LabelTitle = "LabelTitle",
  ActiveLabelTitle = "ActiveLabelTitle",
  ActiveLabelDescription = "ActiveLabelDescription",
  LineSeparator = "LineSeparator",
  InactiveLineSeparator = "InactiveLineSeparator",
  Node = "Node",
  ActiveNode = "ActiveNode",
  InActiveNode = "InActiveNode",
  CompletedNode = "CompletedNode"
}
